<template>
  <div class="summary">
    <div class="card-title semibold px-2 py-2">
      Item Summary
    </div>
    <v-divider></v-divider>
    <div class="px-2 py-2">
      <item-summary :item="project"></item-summary>
    </div>
    <v-divider></v-divider>
    <div v-if="hasFiles" class="px-2 py-2">
      <div v-if="project.file.files.preview"><a @click.prevent="saveItem(project.file.files.preview, true)">Preview File</a></div>
      <div v-if="project.file.files.cover"><a @click.prevent="saveItem(project.file.files.cover, true)">Cover File</a></div>
      <div v-if="project.file.files.content"><a @click.prevent="saveItem(project.file.files.content, true)">Content File</a></div>
      <div v-if="project.file.files.original"><a @click.prevent="saveItem(project.file.files.original, true)">Original File</a></div>
    </div>
    <v-divider v-if="hasFiles"></v-divider>
    <div class="center-align px-2 py-4">
      <fancy-price :price="unitPrice()">{{nextPrice()}}</fancy-price>
      <div>
        <span class="cart-control center-align">
          <v-icon @mousedown="changeQuantity(-1)">mdi-minus</v-icon>
          <input class="quantity" name="quantity" size=4 maxlength=3 v-model="quantity" placeholder="QTY" mast="###">
          <v-icon @mousedown="changeQuantity(1)">mdi-plus</v-icon>
        </span>
      </div>
    </div>
    <v-btn block
           @click="updateCart(project.id, quantity)"
           :color="valid ? 'primary' : 'disabled'"
           :depressed="!valid">Process Order</v-btn>
  </div>
</template>

<script>
  import FancyPrice from '../../widgets/fancy-price'
  import ItemSummary from '../../widgets/item-summary'
  import Events from '@/api/events'

  export default {
    components: {
      fancyPrice: FancyPrice,
      itemSummary: ItemSummary
    },

    props: {
      project: Object,
      valid: Boolean,
      hasFiles: Boolean
    },

    data () {
      return {
        quantity: 1
      }
    },

    watch: {
      'quantity': function () {
        if (parseInt(this.quantity) >= 500) {
          this.quantity = 1
          Events.$emit('error', 'Please Contact Gung-Ho for pricing on 500+ quantities')
        }
      }
    },

    methods: {
      nextPrice () {
        if (this.quantity < 5) {
          return this.$options.filters.currency(this.project.unit_prices[5]) + ' for 5–99 Qty'
        } else if (this.quantity < 100) {
          return this.$options.filters.currency(this.project.unit_prices[100]) + ' for 100-249 Qty'
        } else if (this.quantity < 250) {
          return this.$options.filters.currency(this.project.unit_prices[250]) + ' for 250-499 Qty'
        } else {
          return ''
        }
      },

      unitPrice () {
        if (this.quantity >= 250 && this.quantity < 500) return this.project.unit_prices[250]
        else if (this.quantity >= 100 && this.quantity < 250) return this.project.unit_prices[100]
        else if (this.quantity >= 5 && this.quantity < 100) return this.project.unit_prices[5]
        if (this.quantity < 5) return this.project.unit_prices[1]
      },

      changeQuantity (by) {
        this.quantity = parseInt(this.quantity)
        if ((this.quantity + by) > -1 && (this.quantity + by) < 500) {
          this.quantity += by
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// summary.vue?4e13cba6